<template>
    <v-container class="pa-0 ma-0">
        <v-row no-gutters v-for="contact in contacts" :key="contact.name" class="py-1">
            <v-col
                cols="10"
                md="3">
                {{ contact.name }}
            </v-col>
            <v-col
                cols="12"
                sm="8">
                <a :href="`tel:${contact.phoneNumber}`" style="text-decoration: none;">
                    <v-chip>
                        <v-icon left>mdi-phone</v-icon>
                        {{ contact.phoneNumber }}
                    </v-chip>
                </a>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        contacts: [
            {
                name: "Rescue PO Hanson",
                phoneNumber: "070-587 80 46",
            },
            {
                name: "Grötvik Skeppartelefon",
                phoneNumber: "070-580 81 42",
            },
            {
                name: "Falkenberg Skeppartelefon",
                phoneNumber: "070-580 81 43",
            },
            {
                name: "Torekov Skeppartelefon",
                phoneNumber: "070-580 81 41",
            },
            {
                name: "Grötvik UM",
                phoneNumber: "076-879 31 62",
            },
        ]
    })
}
</script>